module.exports = __webpack_public_path__ + "files/2aac30935d9eeb415ff87f17f96ce762.png";